import { render, staticRenderFns } from "./ListaDisciplinaObjetivo.vue?vue&type=template&id=64d119b8"
import script from "./ListaDisciplinaObjetivo.vue?vue&type=script&lang=js"
export * from "./ListaDisciplinaObjetivo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports